import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: "app-hakkimizda",
  templateUrl: "./hakkimizda.component.html",
  styleUrls: ["./hakkimizda.component.scss"],
})
export class HakkimizdaComponent implements OnInit {
  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    scrollToTop();

    this.metaService.set({
      title: "Hakkımızda - Bilgesin",
      description:
        "Kazan kazan felsefesini iş dünyasına yansıtma düşüncesiyle 2023’de kurulduk. İlk günden beri hem kurumlara hem de bireylere fayda sağlama amacına yönelik çalışmaktayız.",
    });
  }
}
